import { ShieldAlert } from "lucide-react";

import { ColocaAlert } from "@/shared/components/feedback/ColocaAlert";
import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import type { TurnstileController } from "../hooks/useTurnstile";

interface TurnstileWidgetProps {
  turnstile: TurnstileController;
  className?: string;
}

/**
 * The widget only draws itself when it needs the person (`interaction-only`), so while it works in the
 * background a line says why the submit button is still waiting.
 */
export function TurnstileWidget({ turnstile, className }: TurnstileWidgetProps) {
  const { t } = useTranslations("login");
  const { enabled, token, failed, attachContainer } = turnstile;
  if (!enabled) return null;

  return (
    <div className={cn("flex w-full flex-col items-center gap-2", className)}>
      <div ref={attachContainer} className="w-full" />
      {failed ? (
        <ColocaAlert variant="warning" icon={ShieldAlert} text={t("captcha_failed")} className="w-full" />
      ) : (
        !token && (
          <p role="status" className="text-xs text-muted-foreground">
            {t("captcha_checking")}
          </p>
        )
      )}
    </div>
  );
}
